// extracted by mini-css-extract-plugin
export default {"Frame":"cancel-prompt_Frame__7F8q+"};